import { render } from "./SuperAdminGeneralReport.vue?vue&type=template&id=7a4ba02a&scoped=true"
import script from "./SuperAdminGeneralReport.vue?vue&type=script&lang=js"
export * from "./SuperAdminGeneralReport.vue?vue&type=script&lang=js"

import "./SuperAdminGeneralReport.vue?vue&type=style&index=0&id=7a4ba02a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a4ba02a"]])

export default __exports__